import {
  DurationOption,
  getDurationOptionFromTime
} from "@/features/reserve/utils/utils-reserve";
import { loadTimeSelectOptions } from "../utils/timeSelectUtils";

export const loadDurationOptions = (
  filterValue: string,
  startTime: Date,
  durationOptions: DurationOption[]
) => {
  return loadTimeSelectOptions({
    options: durationOptions,
    filterValue,
    baseDate: startTime,
    createOption: getDurationOptionFromTime,
    searchOption: (option, filter) =>
      option.label.toLowerCase().includes(filter.toLowerCase()) ||
      option.label.padStart(7, "0").toLowerCase().includes(filter.toLowerCase())
  });
};
